// extracted by mini-css-extract-plugin
export default {"colorSquaredDot":"QJhUWIQ1epijF0_WVzD_","outline":"WDY7bvHEt2iJ__Zhwdi3"};